export interface Props {
  tokenId: string;
  className?: string;
  name: string;
  imageUrl: string | undefined;
  isLoading: boolean;
  assetAddress?: string;
}

export const AssetImage = ({
  imageUrl,
  name,
  tokenId,
  className,
  isLoading,
  assetAddress,
  ...rest
}: Props) => {
  if (isLoading || !imageUrl) {
    return (
      <div
        className={`${
          className ?? ''
        } bg-gray-300 aspect-square flex justify-center items-center text-xs p-1`}
        title={tokenId}
        {...rest}
      >
        <span className="truncate">{tokenId}</span>
      </div>
    );
  }

  return (
    <img
      className={`${className ?? 'w-full'}`}
      src={imageUrl}
      alt={`${name} ${tokenId}`}
      loading="lazy"
      {...rest}
    />
  );
};

export default AssetImage;
